// ** Data transport (new): @salespark/api-client — resolves the SalesPark
// { status, data } contract natively (no raw-axios wrapper needed).
import { withAuth } from "@salespark/api-client";

/******************************************************************
 * ##: flixApiClient
 * Builds the Flix HTTP client on @salespark/api-client (the current
 * transport standard). Auth headers mirror the learner API contract
 * (x-email + Authorization token); a 401/403 reloads the page, same
 * behaviour as the legacy src/api `checkAuth`. Flix-only for now — the
 * rest of academy-v2 still uses raw axios (gradual migration).
 * @param {Object} authUser - auth.user (carries email + token)
 * @returns {Object} - configured api-client instance ({ status, data })
 * History:
 * 16-09-2026: Created
 ******************************************************************/
const flixApiClient = (authUser) =>
  withAuth({
    baseURL: process.env.REACT_APP_API_URL,
    authHeaders: { "x-email": authUser?.email, Authorization: authUser?.token },
    timeout: 60000,
    onAuthError: () => window.location.reload(),
  });

/******************************************************************
 * ##: flixCoursesList
 * Loads the Flix catalog from the Flix-only endpoint (per-pack cards
 * for flag-enabled courses, every other course unchanged). Returns the
 * SalesPark contract directly from api-client.
 * @param {Object} authUser - auth.user (carries email + token)
 * @returns {Promise<{status:boolean,data:*}>} - SalesPark contract
 * History:
 * 16-09-2026: Created
 ******************************************************************/
export const flixCoursesList = (authUser) => flixApiClient(authUser).getMany("/users/flix/courses");

export default flixCoursesList;
